import { useState, useEffect } from "react";

export function SerialSearchSelect({ token, onSelect, placeholder, loadAll, excludeIds = [] }) {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    useEffect(() => {
        const timer = setTimeout(async () => {
            if (query.length > 1) {
                if (!token) return;

                try {
                    const data = await loadAll(token, 15, 0, query);

                    const filtered = (data || []).filter(item => !excludeIds.includes(item.id));

                    setResults(filtered);
                    setIsDropdownOpen(true);
                } catch (e) {
                    console.error("Search failed", e);
                }
            } else {
                setResults([]);
                setIsDropdownOpen(false);
            }
        }, 400);

        return () => clearTimeout(timer);
    }, [query, token, loadAll, excludeIds]);

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder={placeholder}
                style={{
                    width: '100%', padding: '12px', borderRadius: '10px',
                    border: '2px solid #4f46e5', outline: 'none', boxSizing: 'border-box',
                    fontSize: '14px', transition: 'border-color 0.2s'
                }}
                onFocus={() => query.length > 1 && setIsDropdownOpen(true)}
                onBlur={() => setTimeout(() => setIsDropdownOpen(false), 200)}
            />

            {isDropdownOpen && (
                <div style={{
                    position: 'absolute', top: '105%', left: 0, right: 0,
                    backgroundColor: '#fff', border: '1px solid #d1d5db',
                    borderRadius: '10px', zIndex: 1000, boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
                    maxHeight: '250px', overflowY: 'auto'
                }}>
                    {results.length > 0 ? results.map(serial => {
                        const isTaken = serial.franchiseSerials && serial.franchiseSerials.length > 0;
                        return (
                            <div
                                key={serial.id}
                                onClick={() => {
                                    if (isTaken) {
                                        alert(`Цей серіал уже додано до іншої франшизи!`);
                                        return;
                                    }
                                    onSelect(serial);
                                    setQuery("");
                                    setIsDropdownOpen(false);
                                }}
                                style={{
                                    padding: '10px 15px',
                                    cursor: isTaken ? 'not-allowed' : 'pointer',
                                    borderBottom: '1px solid #f3f4f6',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    opacity: isTaken ? 0.6 : 1,
                                    backgroundColor: isTaken ? '#f9fafb' : '#fff'
                                }}
                                onMouseEnter={(e) => !isTaken && (e.currentTarget.style.backgroundColor = '#f5f3ff')}
                                onMouseLeave={(e) => !isTaken && (e.currentTarget.style.backgroundColor = '#fff')}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <span style={{
                    fontWeight: '600',
                    color: isTaken ? '#9ca3af' : '#1f2937',
                    fontSize: '14px'
                }}>{serial.name} </span>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {serial.year && (
                                            <span style={{ color: '#9ca3af', fontSize: '12px' }}>{serial.year}</span>
                                        )}
                                        {serial.season && (
                                            <span style={{
                                                backgroundColor: isTaken ? '#e5e7eb' : '#eef2ff',
                                                color: isTaken ? '#6b7280' : '#6366f1',
                                                padding: '1px 5px',
                                                borderRadius: '4px',
                                                fontSize: '10px',
                                                fontWeight: 'bold',
                                                border: `1px solid ${isTaken ? '#d1d5db' : '#c3dafe'}`
                                            }}>{serial.season}</span>
                                        )}
                                    </div>
                                </div>

                                {isTaken && (
                                    <span style={{ fontSize: '10px', color: '#ef4444', fontWeight: '500' }}>🔒 Зайнято</span>
                                )}
                            </div>
                        );
                    }) : (
                        <div style={{ padding: '20px', color: '#9ca3af', textAlign: 'center', fontSize: '13px' }}>
                            Нічого не знайдено 🔍
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}